import {
    createRouter,
    createWebHistory
} from "vue-router";
// import axios from 'axios';
import routes from "./routes";
import appConfig from "../../app.config";
import store from "../state/store";
import {ref} from "vue";

const isLoggedIn = ref(false);

const router = createRouter({
    history: createWebHistory(),
    routes,
    // Simulate native-like scroll behavior when navigating to a new
    // route and using back/forward buttons.
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {top: 0, left: 0};
        }
    },
});

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired);
    const requiredRole = routeTo.meta.role;
    if (routeTo.name === "logout") {
        store.dispatch("auth/logOut");
    }

    if (!authRequired) {
        return next();
    }

    if (requiredRole && requiredRole !== store.getters["auth/role"]) {
        next("/");
    }

    if (store.getters["auth/loggedIn"]) {
        next();
    } else {
        next({name: "login", query: {redirectFrom: routeTo.fullPath}});
    }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
    // Create a `beforeResolve` hook, which fires whenever
    // `beforeRouteEnter` and `beforeRouteUpdate` would. This
    // allows us to ensure data is fetched even when params change,
    // but the resolved route does not. We put it in `meta` to
    // indicate that it's a hook we created, rather than part of
    // Vue Router (yet?).
    try {
        // For each matched route...
        for (const route of routeTo.matched) {
            await new Promise((resolve, reject) => {
                // If a `beforeResolve` hook is defined, call it with
                // the same arguments as the `beforeEnter` hook.
                if (route.meta && route.meta.beforeResolve) {
                    route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
                        // If the user chose to redirect...
                        if (args.length) {
                            // If redirecting to the same route we're coming from...
                            // Complete the redirect.
                            next(...args);
                            reject(new Error("Redirected"));
                        } else {
                            resolve();
                        }
                    });
                } else {
                    // Otherwise, continue resolving the route.
                    resolve();
                }
            });
        }
        // If a `beforeResolve` hook chose to redirect, just return.
    } catch (error) {
        return;
    }
    document.title = routeTo.meta.title + " | " + appConfig.title;
    // If we reach this point, continue resolving the route.
    next();
});

export default router;
